import { render, staticRenderFns } from "./ProductionPrefecture.vue?vue&type=template&id=4675ede4&scoped=true&lang=pug&"
import script from "./ProductionPrefecture.vue?vue&type=script&lang=js&"
export * from "./ProductionPrefecture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4675ede4",
  null
  
)

export default component.exports